import { isNetworkSectionsGeoLayer } from 'utils/networkShapefileExport';

export interface ShapefileExportLayerContext {
  readonly layerId: string;
  readonly layerUrl?: string;
  readonly layerName?: string;
}

function normalizeUrl(url?: string): string {
  return (url ?? '').toLowerCase();
}

function isSurveyGeoUrl(url: string): boolean {
  return (
    /\/surveys\/types\//.test(url) ||
    /\/surveys\/inspection-types\//.test(url)
  );
}

function isSchemeOrPerformanceGeoUrl(url: string): boolean {
  return (
    /\/performance\//.test(url) ||
    /\/accidents\//.test(url) ||
    /\/schemes\//.test(url)
  );
}

function isAssetGeoUrl(url: string): boolean {
  return /\/assets\/types\/[^/]+\/assets\/geo/.test(url);
}

function isMapSourcedGeoExportUrl(url: string): boolean {
  if (isAssetGeoUrl(url)) {
    return false;
  }
  return isSurveyGeoUrl(url) || isSchemeOrPerformanceGeoUrl(url);
}

/*
  Survey/scheme/performance geo layers already expose export fields on each
  queried feature. Asset geo layers still need per-asset enrichment so Asset
  Hub fields (getAssetDetails + getAssetAttributes) are included in the export.
 */
export function shouldEnrichLayerFeaturesForExport(
  context: ShapefileExportLayerContext,
): boolean {
  if (isNetworkSectionsGeoLayer(context.layerId)) {
    return true;
  }

  const url = normalizeUrl(context.layerUrl);
  if (!url) {
    return true;
  }

  if (isMapSourcedGeoExportUrl(url)) {
    return false;
  }

  return true;
}
